<template>
  <div>
    <BaseLink :href="`/${locale}`">
      <div class="logo">
        <div class="logo-circle">
          <BasePicture
            class="header__logo"
            src="/logos/logo-black-new.svg"
          />
        </div>
        MyDonut
      </div>
    </BaseLink>
  </div>
</template>

<script lang="ts" setup>
const { locale } = useI18n();
</script>

<style>
.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 700;
  font-size: 20px;
  font-family:
    "Plus Jakarta Sans",
    "Inter",
    system-ui,
    -apple-system,
    sans-serif;
}
.logo-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
